import { DialogObject } from '../../../../components/dialog/dialog.types';
import { TranslateService } from '@ngx-translate/core';

interface getEmailTraceResendDialogObjectProps {
  t: TranslateService;
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getEmailTraceResendDialogObject = ({
  t,
  representation,
  action,
  toggleVisiblity,
}: getEmailTraceResendDialogObjectProps): DialogObject => {
  return {
    title: t.instant('settings.emailTrace.resend.confirmTitle'),
    description: t.instant('settings.emailTrace.resend.confirmDescription', {
      email: representation,
    }),
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide: () => {},
    actions: [
      {
        label: t.instant('common.dialog.cancel'),
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: toggleVisiblity || (() => {}),
        variant: 'secondary',
      },
      {
        label: t.instant('common.dialog.confirm'),
        onClick: action,
        variant: 'danger',
      },
    ],
  };
};
